import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import ru from 'vuetify/lib/locale/ru';

import ThemeLoader from '@/components/common/ThemeLoader.vue';

Vue.use(Vuetify);

// Обертки над компонентами Vuetify для применения настроек интерфейса по умолчанию
Vue.component('ThemeLoader', ThemeLoader);

export default new Vuetify({
  lang: {
    locales: { ru },
    current: 'ru',
  },
  theme: {
    dark: false,
    options: {
      customProperties: false,
      variations: false,
    },
    disable: true
  },
  icons: {
    iconfont: 'mdiSvg',
  },
});
